import { useSvgParsedStyle } from '@/_shared/hooks/useSvgParsedStyle';
import { SvgProps } from '@/_shared/types/svg';

export const Moon = ({ style }: SvgProps) => {
  const { primaryColorToUse, heightToUse, widthToUse } = useSvgParsedStyle({
    defaultWidth: '23',
    defaultHeight: '23',
    style,
  });

  return (
    <svg
      width={widthToUse}
      height={heightToUse}
      viewBox='0 0 23 23'
      xmlns='http://www.w3.org/2000/svg'
      stroke={primaryColorToUse}
      strokeWidth='2.21875'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    >
      <path d='M11.0938 2.77344C9.99041 3.87678 9.37056 5.37323 9.37056 6.93359C9.37056 8.49395 9.99041 9.99041 11.0938 11.0937C12.1971 12.1971 13.6935 12.8169 15.2539 12.8169C16.8143 12.8169 18.3107 12.1971 19.4141 11.0937C19.4141 12.7394 18.9261 14.348 18.0118 15.7163C17.0976 17.0845 15.7981 18.151 14.2778 18.7807C12.7575 19.4105 11.0845 19.5752 9.47054 19.2542C7.85656 18.9331 6.37402 18.1407 5.2104 16.9771C4.04679 15.8135 3.25435 14.3309 2.93331 12.717C2.61227 11.103 2.77704 9.43004 3.40679 7.9097C4.03653 6.38937 5.10297 5.08991 6.47124 4.17566C7.8395 3.26142 9.44815 2.77344 11.0938 2.77344Z' />
    </svg>
  );
};
